import axios from './../api.js'

const state = {
  projects: []
}

const getters = {
  getProjects: state => {
    return state.projects
  }
}

const mutations = {
  setProjects: (state, payload) => {
    state.projects = payload
  },
  removeProject: (state, payload) => {
    state.projects = state.projects.filter(project => project.projectId !== payload)
  }
}

const actions = {
  async setProjects ({ commit }) {
    try {
      const response = await axios.get('/Public/GetProjectList')
      if (response) {
        commit('setProjects', response.data)
      }
    } catch (err) {
      throw err
    }
  },
  async validateProjectName ({ commit }, projectName) {
    try {
      const response = await axios.get('/Public/ValidateProjectName?ProjectName=' + projectName)
      return response.data
    } catch (err) {
      throw err
    }
  },
  async removeProject ({ commit }, projectId) {
    try {
      const response = await axios.get('/Public/DeleteProject?ProjectId=' + projectId)
      if (response) {
        commit('removeProject', projectId)
      }
    } catch (err) {
      throw err
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
